export enum ToolSetupParameterState {
  NotSet = 'NotSet',
  Correct = 'Correct',
  Dummy = 'Dummy',
  Incorrect = 'Incorrect'
}
